import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="trash">
        <g id="icon">
          <path d="M11.3636 9V16.5H10.0909V9H11.3636Z" fill="currentcolor" />
          <path d="M13.9091 9V16.5H12.6364V9H13.9091Z" fill="currentcolor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0909 4C9.388 4 8.81818 4.55964 8.81818 5.25V6.5H5V7.75H6.27273V16.5C6.27273 17.8807 7.41237 19 8.81818 19H15.5C16.7301 19 17.7273 18.0206 17.7273 16.8125V7.75H19V6.5H15.1818V5.25C15.1818 4.55964 14.612 4 13.9091 4H10.0909ZM16.4545 7.75H7.54545V16.5C7.54545 17.1904 8.11527 17.75 8.81818 17.75H15.5C16.0272 17.75 16.4545 17.3303 16.4545 16.8125V7.75ZM13.9091 6.5H10.0909V5.875C10.0909 5.52982 10.3758 5.25 10.7273 5.25H13.2727C13.6242 5.25 13.9091 5.52982 13.9091 5.875V6.5Z"
            fill="currentcolor"
          />
        </g>
      </g>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-trash" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
